import 'whatwg-fetch';
import Cookies from 'js-cookie';
import config from './config.js';
import { guid } from '../utils';
import _ from 'underscore';

const userSessionId = guid();

function mutationRequest(methodType, relativeUri, details) {
    const request = new Request(`${config.baseAddress}/api/${relativeUri}`, {
        method: methodType,
        body: JSON.stringify(details),
        credentials: config.fetchCredentialsHeader,
        headers: new Headers({
            'Content-Type': 'application/json',
            'X-Csrf-Token': Cookies.get('AntiForgeryToken'),
            'X-SqlClone-UserSessionId': userSessionId
        })
    });

    return fetch(request);
}

export default {
    post: (relativeUri, details) => mutationRequest('POST', relativeUri, details),
    put: (relativeUri, details) => mutationRequest('PUT', relativeUri, details),
    deleteItem: (relativeUri) => mutationRequest('DELETE', relativeUri),

    //params takes form of { key1: value1, key2: value2 };
    get: (relativeUri, params = {}) => {

        let str = `${config.baseAddress}/api/${relativeUri}`;

        const paramKeys = _(params).keys();
        if (paramKeys.length > 0)
        {
            let queryString = '?';
            paramKeys.forEach(key => queryString += `${key}=${params[key]}`);
             str += queryString;
        }
        
        const request = new Request(str,
        {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
                'X-SqlClone-UserSessionId': userSessionId
            }),
            credentials: config.fetchCredentialsHeader
        });

        return fetch(request);
    }
};



// WEBPACK FOOTER //
// ./src/js/serverApi/requestTypes.js